import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-NEFFPWG1NK';

if (process.env.NODE_ENV === 'production') {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const gaScript = document.createElement('script');
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  gaScript.onerror = function noop() {};
  document.head.appendChild(gaScript);
}

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
